import { GET_PARAM, GET_PARAM_SUCCESS, GET_PARAM_ERROR} from './actionTypes';

export const getParameters = (user) => {
    return {
        type: GET_PARAM,
        payload: { user }
    }
}

export const getParametersSuccess = (param, message) => {
    return {
        type: GET_PARAM_SUCCESS,
        payload: {param, message}
    }
}

export const getParametersError = (param) => {
    return {
        type: GET_PARAM_ERROR,
        payload: param
    }
}
